"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingEvent = void 0;
var TrackingEvent;
(function (TrackingEvent) {
    TrackingEvent["Start"] = "start";
    TrackingEvent["Pause"] = "pause";
    TrackingEvent["Resume"] = "resume";
    TrackingEvent["Error"] = "error";
    TrackingEvent["Click"] = "click";
    TrackingEvent["Rewind"] = "rewind";
    TrackingEvent["Impression"] = "impression";
    TrackingEvent["CreativeView"] = "creativeView";
    TrackingEvent["Complete"] = "complete";
})(TrackingEvent = exports.TrackingEvent || (exports.TrackingEvent = {}));
//# sourceMappingURL=vast.js.map